import React from 'react';
import PreferencesAccordion from 'components/PreferencesAccordion';
import usePreferences from 'hooks/Meteorology/Weather/Comparator/usePreferences';
import useSelectPreference from 'hooks/Meteorology/Weather/Comparator/useSelectPreference';
import useDeletePreference from 'hooks/Meteorology/Weather/Comparator/useDeletePreference';

export default function Preferences() {
  const { preferences } = usePreferences();
  const { preferenceDeleteTrigger, deleteLoading } = useDeletePreference();
  const { selectPreferenceTrigger } = useSelectPreference();

  return (
    <PreferencesAccordion
      preferenceList={preferences}
      selectTrigger={selectPreferenceTrigger}
      deleteTrigger={preferenceDeleteTrigger}
      deleteLoading={deleteLoading}
    />
  );
}
